/* NEW: UI_REVAMP */
export const CALENDAR_MIN_DATE = new Date(2023, 1, 1);

export const dateRangeCalendarStyles = {
	'& .react-datepicker': {
		width: '100%',
		boxSizing: 'border-box',
		border: '1px solid #D8CDFD',
		borderRadius: '8px',
		background: '#FFFFFF',
		padding: '8px 8px 10px',
	},
	'& .react-datepicker__month-container': {
		width: '100%',
	},
	'& .react-datepicker__header': {
		background: 'transparent',
		borderBottom: 0,
		paddingTop: 0,
	},
	'& .react-datepicker__current-month, & .react-datepicker-time__header, & .react-datepicker-year-header':
		{
			display: 'none',
		},
	'& .react-datepicker__day-names, & .react-datepicker__week': {
		display: 'grid',
		gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
		width: '100%',
		margin: '0 auto',
	},
	'& .react-datepicker__day-names': {
		marginBottom: '4px',
	},
	'& .react-datepicker__week': {
		paddingTop: '10px',
		paddingBottom: '10px',
	},
	'& .react-datepicker__day-name': {
		width: '100%',
		height: '24px',
		lineHeight: '24px',
		minWidth: 0,
		margin: 0,
		fontSize: '14px',
		fontWeight: 500,
		color: '#595959',
		textAlign: 'center',
	},
	'& .react-datepicker__month': {
		width: '100%',
		margin: 0,
	},
	'& .react-datepicker__day': {
		position: 'relative',
		width: '100%',
		height: '24px',
		lineHeight: '24px',
		minWidth: 0,
		margin: 0,
		borderRadius: 0,
		background: 'transparent',
		fontSize: '14px',
		fontWeight: 400,
		color: '#262626',
		textAlign: 'center',
	},
	'& .calendar-day-content': {
		position: 'relative',
		zIndex: 1,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '24px',
		height: '24px',
		margin: '4px auto',
		border: '1px solid transparent',
		borderRadius: '4px',
		lineHeight: '24px',
		marginTop: '0px',
	},
	'& .calendar-day-content:hover': {
		background: '#c6c1e5',
	},
	'& .react-datepicker__day--outside-month': {
		color: '#BFBFBF',
	},
	'& .react-datepicker__day--disabled': {
		background: 'transparent',
		color: '#D9D9D9',
		cursor: 'not-allowed',
	},
	'& .react-datepicker__day--in-range': {
		background: '#E6F4FF',
		color: '#262626',
	},
	'& .react-datepicker__day--range-start': {
		background: 'linear-gradient(90deg, transparent 0 50%, #E6F4FF 50% 100%)',
	},
	'& .react-datepicker__day--range-end': {
		background: 'linear-gradient(90deg, #E6F4FF 0 50%, transparent 50% 100%)',
	},
	'& .react-datepicker__day--range-start.react-datepicker__day--range-end': {
		background: 'transparent',
	},
	'& .react-datepicker__day--range-start .calendar-day-content, & .react-datepicker__day--range-end .calendar-day-content, & .react-datepicker__day--selected .calendar-day-content':
		{
			borderColor: '#1677FF',
			background: '#1677FF',
			color: '#FFFFFF',
		},
	'& .react-datepicker__day--keyboard-selected:not(.react-datepicker__day--in-range)': {
		background: 'transparent',
	},
	'& .react-datepicker__day.calendar-day--today:not(.react-datepicker__day--in-range):not(.react-datepicker__day--selected) .calendar-day-content':
		{
			borderColor: '#1677FF',
			background: '#FFFFFF',
			color: '#262626',
			fontWeight: 400,
		},
	'& .react-datepicker__day.calendar-day--single-selected': {
		background: 'transparent',
	},
	'& .react-datepicker__day.calendar-day--single-selected .calendar-day-content': {
		borderColor: '#1677FF',
		background: '#1677FF',
		color: '#FFFFFF',
	},
};
